<template>
  <section :class="['container mx-auto px-8', lifted ? 'sm:mt-[9rem] md:mt-[-5rem]' : '', paddingClass, sectionClass, containerClass]">
    <div :class="['w-full', maxWidthClass, contentClass]">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';

type ClassValue = string | undefined;

const props = defineProps<{
  lifted?: boolean;
  maxWidthClass?: ClassValue;
  paddingClass?: ClassValue;
  contentClass?: ClassValue;
  containerClass?: ClassValue;
  sectionClass?: ClassValue;
}>();

const maxWidthClass = computed(() => props.maxWidthClass ?? 'max-w-[1100px] mx-auto');
const paddingClass = computed(() => props.paddingClass ?? 'py-6 sm:py-7 md:py-8 lg:py-10');
const contentClass = computed(() => props.contentClass ?? '');
const containerClass = computed(() => props.containerClass ?? '');
const sectionClass = computed(() => props.sectionClass ?? '');
const lifted = computed(() => props.lifted ?? false);
</script>
